import { combineReducers } from 'redux';

import home from './home.reducers';
import permissions from './permissions.reducers';
import schedule from './schedule.reducers';
import calendar from './calendar.reducers';
import notice from './notice.reducers';
import announcement from './announcement.reducers';

const dashboardReducers = combineReducers({
  home,
  permissions,
  schedule,
  calendar,
  notice,
  announcement,
});

export default dashboardReducers;
